import { createContext, useContext, type ReactNode } from "react"
import type { CameraPickerPreset } from "@/components/cameras/camera-picker-dialog"

export type CameraPresetsContextValue = {
  projectId: number | null
  presets: CameraPickerPreset[]
  setPresets: (presets: CameraPickerPreset[]) => void
}

const CameraPresetsContext = createContext<CameraPresetsContextValue>({
  projectId: null,
  presets: [],
  setPresets: () => undefined,
})

export function CameraPresetsProvider({
  projectId,
  presets,
  onPresetsLoaded,
  children,
}: {
  projectId?: number | null
  presets: CameraPickerPreset[]
  onPresetsLoaded?: (presets: CameraPickerPreset[]) => void
  children: ReactNode
}) {
  return (
    <CameraPresetsContext.Provider
      value={{
        projectId: projectId ?? null,
        presets,
        setPresets: onPresetsLoaded ?? (() => undefined),
      }}
    >
      {children}
    </CameraPresetsContext.Provider>
  )
}

export function useCameraPresets(): CameraPickerPreset[] {
  return useContext(CameraPresetsContext).presets
}

export function useCameraPresetsContext(): CameraPresetsContextValue {
  return useContext(CameraPresetsContext)
}
